import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiUrl, formatApiError, formatCDF } from "../../lib/api";
import AdminShell from "../../components/AdminShell";
import { Badge, Button, Card, StatusBadge } from "../../components/ui-kit";

export default function AdminRides() {
  const [rides, setRides] = useState([]);

  useEffect(() => {
    const load = () =>
      api
        .get("/admin/rides")
        .then(({ data }) => setRides(data))
        .catch((e) => toast.error(formatApiError(e)));
    load();
    const int = setInterval(load, 4000);
    return () => clearInterval(int);
  }, []);

  return (
    <AdminShell title="Courses">
      <div className="admin-page-header">
        <div className="min-w-0">
          <h1 className="responsive-title font-heading text-3xl font-black tracking-tighter sm:text-4xl">Toutes les courses</h1>
          <p className="text-sm text-muted-foreground">Suivi operationnel, paiements et exports.</p>
        </div>
        <div className="admin-actions">
          <a href={apiUrl("/admin/rides/export.csv")} target="_blank" rel="noreferrer">
            <Button>CSV</Button>
          </a>
          <a href={apiUrl("/admin/rides/export.pdf")} target="_blank" rel="noreferrer">
            <Button variant="outline">PDF</Button>
          </a>
        </div>
      </div>
      <Card className="mt-6 overflow-x-auto">
        <table className="admin-table w-full text-sm">
          <thead className="border-b-2 border-foreground bg-secondary text-secondary-foreground">
            <tr>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">ID</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Client</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Chauffeur</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Service</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Type</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Prix</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Paiement</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Statut</th>
              <th className="p-3 text-left text-[10px] font-black uppercase tracking-widest">Créée</th>
            </tr>
          </thead>
          <tbody>
            {rides.map((r) => (
              <tr key={r.id} className="border-b border-border" data-testid={`admin-ride-${r.id}`}>
                <td className="p-3 font-mono text-xs">#{r.id.slice(0, 6).toUpperCase()}</td>
                <td className="p-3">{r.customer_name}</td>
                <td className="p-3">{r.driver_name || "—"}</td>
                <td className="p-3">
                  <Badge tone={r.service_type === "delivery" ? "success" : "primary"}>
                    {r.service_type === "delivery" ? "Livraison" : "Course"}
                  </Badge>
                </td>
                <td className="p-3">
                  {r.vehicle_type}
                  {r.service_type === "delivery" && r.delivery?.package_size && (
                    <div className="mt-1 text-[10px] text-muted-foreground">{r.delivery.package_size}</div>
                  )}
                </td>
                <td className="p-3 font-mono font-bold">{formatCDF(r.price)}</td>
                <td className="p-3 text-xs">{r.payment_method} · {r.payment_status}</td>
                <td className="p-3"><StatusBadge status={r.status} /></td>
                <td className="p-3 text-xs">{new Date(r.created_at).toLocaleString("fr-FR")}</td>
              </tr>
            ))}
            {rides.length === 0 && (
              <tr>
                  <td colSpan={9} className="p-8 text-center text-xs font-bold uppercase tracking-widest text-muted-foreground">
                  Aucune course
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Card>
    </AdminShell>
  );
}
